module.exports = __webpack_public_path__ + "static/media/recomendation-danger.417ff638.svg";